
    <enterprise-banner
      [textMessage]="textMessage"
      [linkMessage]="linkMessage"
      [opReferrer]="referrer">
    </enterprise-banner>
  